/**
*
*/
<template>
    <div>
        <van-nav-bar
                title="房号"
                left-arrow
                :fixed="true"
                :placeholder="true"
                @click-left="onClickLeft"
                @click-right="onClickRight"
        >
<!--            <icon name="chat-o" slot="right" size="20px" info="1" color="#ffffff"></icon>-->
        </van-nav-bar>
        <div>
            <div>
                <cell :title="house.name" :label="house.addr" is-link @click="goToHouse(house.id)" />
            </div>
            <div>
                <Button icon="star-o" type="primary" size="large" @click="goAddRoom">添加房号</Button>
            </div>
            <cell-group>

<!--                <template v-for="{vo, index} in houses">-->
<!--                    {{vo.name}}{{vo.index}}-->
                    <cell  v-for="(vo, index) in rooms" :title="vo.name" :label="vo.roomType + ' ' + vo.rental
                    + '元/月 电表编号:' + vo.electricityMeterSn + ' 水表编号:' + vo.waterMeterSn" :value="formatValue(vo)"
                           is-link :key="'room_' + index" @click="goToTenant(vo)"/>
<!--                </template>-->

            </cell-group>
        </div>
    </div>
</template>

<script>
    import { Grid, GridItem, Icon, Button, Cell, CellGroup } from 'vant';
    import {copyValue} from "@/common/utils";

    // import { NavBar, Toast } from 'vant';
    // import HelloWorld from '@/components/HelloWorld.vue'

    export default {
        name: "index",
        components:{
            // eslint-disable-next-line vue/no-unused-components
            // NavBar,
            Button,
            Cell,
            CellGroup,
            Icon
        },
        data() {
            return {
                house: {
                    id: "",
                    name: "",
                    addr: ""
                },
                rooms: [
                    // {
                    //     id:"1",
                    //     name: "101",
                    //     detail: "",
                    //     status: "闲置",
                    // },
                    // {
                    //     id:"2",
                    //     name: "102",
                    //     detail: "1房1厅1卫 500.00元/月",
                    //     status: "闲置",
                    // },
                    // {
                    //     id:"3",
                    //     name: "103",
                    //     detail: "",
                    //     status: "租客：王老五",
                    // }
                ]
            }
        },
        created() {
            // this.house
            // console.log("params", this.$route.params)
            // copyValue(this.house, this.$route.params);
            console.log("params", this.$route.params)
            copyValue(this.house, this.$route.query);
            this.getRooms()
        },
        mounted() {
            // this.login();
        },
        // activated() {
        //     console.log("activated useCache: ", this.$route.meta.useCache)
        //     if(!this.$route.meta.useCache){
        //         console.log("params", this.$route.params)
        //         copyValue(this.house, this.$route.query);
        //         this.getRooms()
        //     }
        // },
        methods: {
            formatValue(item){
                // 状态：0 闲置，1已租，2预订，3过节未回
                switch (item.status) {
                    case 0:
                        return '闲置';
                    case 1:
                        return '已租';
                    case 2:
                        return '预订';
                    case 3:
                        return '过节未回';
                    default:
                        return item.status;
                }
            },
            getRooms(){
                this.$get('/rooms/list', {houseId: this.house.id}).then(({data})=>{
                    this.rooms = data
                })
            },
            onClickLeft() {
                this.$goBack();
            },
            onClickRight() {
                this.$toast('按钮');
                // Toast('按钮');
            },
            goToTenant(item){
                console.log(item);
                // this.$routers.push("rooms");
                // this.$router.push({path:'tenant'});
                this.$router.push({path:'/tenant', query: {id: item.id}});
            },
            goAddRoom(){
                this.$goPage('/rooms/edit', {houseId: this.house.id});
            },
            goToHouse(houseId){
                this.$goPage('/myhouse/edit', {id: houseId});
            }
        }
    }
</script>

<style scoped lang="less">
    .item-text{
        font-size: 12px;
        color: #8f8f94;
        margin-top: 8px;
    }
    .van-nav-bar{
        background-color: #409EFF;
        .van-nav-bar__title{
            color: #ffffff;
        }
    }
</style>
